module.exports = __webpack_public_path__ + "img/tradein7.bbb418c2.jpg";